import React from 'react';
import { Button, Paper } from 'library';
import { NUMBER_FORMATS } from 'utils/formatters';

import { INQUIRY_URL } from '../../../../constants/links';
import NoButtonCTA from '../NoButtonCTA/NoButtonCTA';

import './AmountCalculatorNoTable.scss';

const AmountCalculatorNoTable = ({ max }) => {
  return (
    <Paper theme="medium" className="AmountCalculatorNoTable">
      <NoButtonCTA amount={NUMBER_FORMATS.currency(max, 0)} />
      <div className="AmountCalculatorNoTableBodyWrapper">
        <div className="AmountCalcTableSubText">
          Hometap invests alongside homeowners, providing cash today and participating in the proceeds at the time of a
          sale or settlement.
        </div>
        <h2>Ready to get started?</h2>
        <Button label="See if I prequalify" href={INQUIRY_URL} className="AmountCalculatorNoTableButton" />
      </div>
      <div className="AmountCalculatorNoTableDisclaimer">
        This estimate is for illustrative purposes only. The estimate assumes a well-qualified homeowner with at least
        25% equity and is based on a 15% investment in the home for a 10-year period. All applications are subject to
        Hometap's then-current underwriting criteria. Investment terms and eligibility requirements are subject to
        change. Your final investment amount is based on the amount of equity you currently have in your home.
      </div>
    </Paper>
  );
};

export default AmountCalculatorNoTable;
